import { DiscountBadge } from 'QuoteApp/components/DiscountBadge';
import React, { FC } from 'react';
import styles from './styles.module.css';

type SummarySectionProps = {
  discountBadgeText?: string;
  headerText: string;
  subHeaderText?: string;
  children?: React.ReactNode;
};

export const SummarySection: FC<SummarySectionProps> = ({
  discountBadgeText,
  headerText,
  subHeaderText,
  children,
}) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.header}>
        {headerText}
        {discountBadgeText && (
          <DiscountBadge className={styles.discountBadge}>
            {discountBadgeText}
          </DiscountBadge>
        )}
      </h3>
      <div className={styles.subText}>{subHeaderText}</div>
      {children}
    </div>
  );
};
